import { useConfig } from '@travelwin/core';

import GoogleTripadvisor from './GoogleTripadvisor/GoogleTripadvisor';
import TrustpilotRatingWidget from './Trustpilot/TrustpilotRatingWidget';

export type Align =
  | 'left'
  | 'right'
  | 'left-tablet-up'
  | 'right-tablet-up'
  | 'center';

export const RatingWidget = ({ align = 'center' }: { align?: Align }) => {
  const {
    TRUSTPILOT_WIDGET_BUSINESS_UNIT_ID,
    TRUSTPILOT_WIDGET_TEMPLATE_ID,
    TRUSTPILOT_WIDGET_DATA_TOKEN,
    TRUSTPILOT_WIDGET_LINK,
  } = useConfig();

  if (
    TRUSTPILOT_WIDGET_BUSINESS_UNIT_ID &&
    TRUSTPILOT_WIDGET_TEMPLATE_ID &&
    TRUSTPILOT_WIDGET_DATA_TOKEN &&
    TRUSTPILOT_WIDGET_LINK
  ) {
    return <TrustpilotRatingWidget align={align} />;
  }

  return <GoogleTripadvisor align={align} />;
};
